export class OrderOperationClaimService {
  static transform (obj) {
    let claimService = {}
    claimService.id = obj.id
    claimService.parentRateId = obj.attributes.parent_rate_id
    claimService.contractId = obj.attributes.contract_id
    claimService.firmId = obj.attributes.firm_id
    claimService.category = obj.attributes.category
    claimService.code = obj.attributes.code
    claimService.ninaCode = obj.attributes.nina_code
    claimService.description = obj.attributes.description
    claimService.uom = obj.attributes.uom
    claimService.rate = obj.attributes.rate
    claimService.displayOrder = obj.attributes.display_order
    claimService.status = obj.attributes.status
    return claimService
  }
}



// WEBPACK FOOTER //
// ./src/helpers/orderOperationClaimServices/orderOperationClaimService.transformer.js